/**
 * «الان صفحه باریکه؟» — تنها جایی که وب درباره‌ی اندازه‌ی صفحه تصمیمِ
 * **جاوااسکریپتی** می‌گیره.
 *
 * چرا اصلاً جاوااسکریپت، وقتی CSS خودش media query داره: چون روی گوشی نوارِ
 * کناری فقط نباید *دیده* بشه، بلکه اصلاً نباید ساخته بشه. پنلِ اون نوار
 * HomePage/FriendsPage رو mount می‌کنه و اون‌ها به‌محضِ mount شدن اعلان‌ها رو
 * «دیده‌شده» علامت می‌زنن. یه `display: none`ِ ساده جلوی این رو نمی‌گیره —
 * نقطه‌ی قرمزِ کاربر بی‌آنکه چیزی دیده باشه پاک می‌شد.
 *
 * ⚠️ عدد ۸۶۰ دو جا نوشته شده: این‌جا و بلوکِ `@media (max-width: 860px)` در
 * `ui/base.css`. اگه یکی عوض شد، اون یکی هم باید — وگرنه یه بازه‌ی باریک
 * می‌مونه که نه منوی سه‌خط داره نه نوارِ کناری.
 */
import { useSyncExternalStore } from 'react';

export const NARROW_QUERY = '(max-width: 860px)';

const mql = () => window.matchMedia(NARROW_QUERY);

function subscribe(onChange: () => void): () => void {
  const m = mql();
  m.addEventListener('change', onChange);
  return () => m.removeEventListener('change', onChange);
}

/** با چرخاندنِ گوشی یا تغییرِ اندازه‌ی پنجره خودش تازه می‌شه. */
export function useIsNarrow(): boolean {
  // آرگومانِ سوم مقدارِ سرور است؛ این اپ SSR نداره ولی امضای هوک می‌خوادش.
  return useSyncExternalStore(subscribe, () => mql().matches, () => false);
}
